import axios from 'axios';

export default function (context, val) {
    context.commit('set_data', val);
    if (val.filters && val.filters.length) {
        val.filters.forEach(i => {
            context.commit('set_filter', i);
        });
    } else {
        context.commit('set_filter');
    }
    context.state.filter = context.state.filters[0].id;
}